module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av349-1cc2c8dfc4633434f8042e42e94e9633.jpg";